import React, { FC, useContext, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Hidden from '@mui/material/Hidden';
import { useTranslation } from 'react-i18next';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import ConstructionsStep from 'components/order-flow/supplier-order/constructions-step/constructions-step.component';
import DeliveryFilesStep from 'components/order-flow/supplier-order/delivery-files-step/delivery-files-step.component';
import ConfirmStep from 'components/order-flow/supplier-order/confirm-step/confirm-step.component';
import PatientSupplierStep from 'components/order-flow/supplier-order/patient-supplier-step/patient-supplier-step.component';
import { SupplierOrderContext } from 'pages/order-flow/supplier-order/supplier-order-context';
import { useParams } from 'react-router-dom';
import { currentOrgVar } from 'apollo/reactive-variables/organization';

const SupplierOrder: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    const [activeStep, setActiveStep] = useState(0);
    const currentOrganization = currentOrgVar();
    const { order } = useContext(SupplierOrderContext);
    const params = useParams<{ id: string }>();

    const getSteps = () => {
        return [
            translate('PATIENT_LAB'),
            translate('CONSTRUCTIONS'),
            translate('DELIVERY_FILES'),
            translate('CONFIRM'),
        ];
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        // For supplier lab user - If we are modifying an order, skip the first step
        if (params.id && order.supplier?._id === currentOrganization._id && order?._id && activeStep === 0) {
            setActiveStep(1);
        }
    }, [activeStep]);

    const getStepContent = () => {
        switch (activeStep) {
            case 0:
                return <PatientSupplierStep onNextClick={handleNext} />;
            case 1:
                return <ConstructionsStep onBackClick={handleBack} onNextClick={handleNext} />;
            case 2:
                return <DeliveryFilesStep onBackClick={handleBack} onNextClick={handleNext} />;
            case 3:
                return <ConfirmStep />;
            default:
                return 'Unknown stepIndex';
        }
    };

    const steps = getSteps();

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepperClick = (step: number) => {
        if (step < activeStep) {
            setActiveStep(step);
        }
    };

    return (
        <Box sx={{ maxWidth: '1200px' }} display="flex" flexDirection="column" mx="auto">
            <Box mb={2}>
                <Hidden mdDown>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => (
                            <Step sx={{ cursor: 'pointer' }} key={label} onClick={() => handleStepperClick(index)}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Hidden>
            </Box>
            <Paper elevation={1}>
                <Box p={3}>{getStepContent()}</Box>
            </Paper>
        </Box>
    );
};

export default SupplierOrder;
